import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import { initUpdateCheck } from './utils/checkForUpdate';
import { registerServiceWorker } from './utils/registerServiceWorker';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/scss/main.scss';
import { watchViewport } from './utils/viewport';
import { installErrorCapture } from './utils/bugContext';
import { trackUsage } from './utils/usage.js';
import './utils/screenPin.js'; // keeps the bug button at the real bottom of the screen (iOS cuts the page short)
import { installPadNav } from './utils/padNav.js';

// One anonymous ping per open → Bug Desk's Visitors tab (house module).
trackUsage('thunder');

// Before the first paint: how much of the screen the layout actually
// reaches. See utils/viewport - this is the dead-band seatbelt.
watchViewport();

// Remember uncaught errors and console.error from the first moment, so a bug
// report says what threw before the player reached the button (bugContext.js).
installErrorCapture();

// Precaches the app shell + card art so local hotseat/solo-vs-AI play works
// fully offline after a first online visit - see registerServiceWorker.js.
registerServiceWorker();

const app = createApp(App);

// Begin listening for auth state before the router's guards run.
store.dispatch('initAuth');
// Resume a saved local (hotseat/solo-vs-AI) game, if any - see
// store/localGameStorage.js. Safe to do unconditionally at boot: a route to
// a remote game overwrites gameState via bindRemoteGame once it mounts.
store.dispatch('loadLocalGame');

// Matt: "it's harder for me to reload the page after you make changes...
// can we make it so [reopening the app] can also detect new changes and
// reload the page?" See checkForUpdate.js's own comment for why detecting
// this needs no service-worker lifecycle hook at all. The store and router
// are what let it tell "sitting on the landing page" (reload freely) from
// "two people are mid-dungeon-run" (never) - see appUpdate.js.
initUpdateCheck({ store, router });

app.use(store);
app.use(router);

app.mount('#app');

// A game controller moves a highlight round the screen and presses things
// (Steam Deck, 2026-11-02). Inert until a pad is connected.
installPadNav();
